module.exports = __webpack_public_path__ + "img/gzmj.112a9a89.png";